<!-- Filter Tabs - Category filtering for agents -->
<div class="filter-tabs-container" role="tablist" aria-label="Agent category filters">
  
  <!-- All Agents Tab (always first) -->
  <button
    class="filter-tab"
    [class.active]="isActive('all')"
    (click)="onTabClick('all')"
    (keydown)="onKeyDown($event, 'all')"
    role="tab"
    [attr.aria-selected]="isActive('all')"
    [attr.tabindex]="isActive('all') ? 0 : -1"
    type="button">
    {{'ALL_BUTTON'| translate}} ({{ totalCount }})
  </button>

  <!-- Dynamic Category Tabs -->
  <button
    *ngFor="let category of categories; trackBy: trackByCategory"
    class="filter-tab"
    [class.active]="isActive(category.id)"
    (click)="onTabClick(category.id)"
    (keydown)="onKeyDown($event, category.id)"
    role="tab"
    [attr.aria-selected]="isActive(category.id)"
    [attr.tabindex]="isActive(category.id) ? 0 : -1"
    type="button">
    {{ category.name | translate }}
  </button>

</div>
